var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoodLib(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 11.6666H18.3333",
    stroke: "white",
    strokeWidth: 0.97,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16666 18.3333L4.94213 17.5578C5.38277 17.1172 5.60309 16.8969 5.8807 16.7716C6.15831 16.6463 6.46928 16.6269 7.09122 16.588L9.80158 16.4186C11.1337 16.3354 11.7997 16.2937 12.3858 16.0123C12.972 15.7308 13.4209 15.237 14.3187 14.2494L16.6667 11.6666H13.75L12.2559 13.1607C12.1566 13.26 12.1068 13.3098 12.0552 13.3536C11.7893 13.5795 11.4593 13.7161 11.1117 13.7445C11.0441 13.75 10.9738 13.75 10.8333 13.75M10.8333 13.75C10.8333 13.3627 10.8333 13.1691 10.8013 13.0081C10.6698 12.347 10.153 11.8301 9.49183 11.6986C9.33083 11.6666 9.13725 11.6666 8.75 11.6666H8.09874C7.22787 11.6666 6.79244 11.6666 6.38412 11.7716C6.07999 11.8498 5.78843 11.9705 5.51809 12.1303C5.15514 12.3448 4.84724 12.6527 4.23145 13.2685L1.66666 15.8333M10.8333 13.75H7.91666",
    stroke: "white",
    strokeWidth: 0.97,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 9.58329C4.16667 5.90138 7.15143 2.91663 10.8333 2.91663M10.8333 2.91663C14.5153 2.91663 17.5 5.90138 17.5 9.58329M10.8333 2.91663V1.66663",
    stroke: "white",
    strokeWidth: 0.97,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodLib);
export default __webpack_public_path__ + "static/media/food_lib.c8650d667dbf93d470a70b37125b6d7b.svg";
export { ForwardRef as ReactComponent };